module.exports = __webpack_public_path__ + "img/104ne.602577da.svg";